import React from 'react';
import classNames from "classnames";
import {analyticsColorScheme} from "../../analytics/color-scheme";

function getScoreLabel(scoreOverrides, rating) {
  return (scoreOverrides || {})[rating] || rating;
}

function getScaledScoreColor(rating, scale) {
  const maxRating = parseInt(scale || 7, 10);
  const numericRating = parseInt(rating, 10);

  if (!numericRating) {
    return null;
  }

  if (analyticsColorScheme[maxRating] && analyticsColorScheme[maxRating][numericRating]) {
    return analyticsColorScheme[maxRating][numericRating];
  }

  return analyticsColorScheme[7][Math.min(Math.max(numericRating, 1), 7)];
}

const RatingValue = ({rating, scale, notObserved, notResponsive, notObservedPrompt, notResponsivePrompt, scoreOverrides}) => {
  if (notObserved) {
    return <div className="evaluation-rating-value muted">{notObservedPrompt}</div>
  }
  if (notResponsive) {
    return <div className="evaluation-rating-value muted">{notResponsivePrompt}</div>
  }
  if (rating) {
    return (
      <div
        className={classNames('evaluation-rating-value')}
        style={{backgroundColor: getScaledScoreColor(rating, scale), color: '#fff'}}>
        {getScoreLabel(scoreOverrides, rating)}
      </div>
    )
  }
  return <div className="evaluation-rating-empty">No response</div>
}

const EvaluationPanel = ({title, value, scale, notObservedPrompt, notResponsivePrompt, scoreOverrides}) => {
  const response = value || {};
  return (
    <div className="evaluation-rating-panel">
      <div className="evaluation-rating-panel-title">{title}</div>
      <RatingValue
        rating={response.rating}
        scale={scale}
        notObserved={response.notObserved}
        notResponsive={response.notResponsive}
        notObservedPrompt={notObservedPrompt}
        notResponsivePrompt={notResponsivePrompt}
        scoreOverrides={scoreOverrides}
      />
      {!!response.comment && (
        <div className="evaluation-rating-comment" dangerouslySetInnerHTML={{__html: response.comment}} />
      )}
    </div>
  )
}

const EvaluationRatingElement = ({
                                   ratingPrompt,
                                   traineeValue,
                                   trainerValue,
                                   notObservedPrompt,
                                   notResponsivePrompt,
                                   scoreOverrides,
                                   scale,
                                   author,
                                   acknowledger
                                 }) => {
  return (
    <div className="dynamic-report-item evaluation-rating-report">
      <div className="label" style={{whiteSpace: 'pre-wrap'}}>
        {ratingPrompt}
      </div>
      <div className="evaluation-rating-panels">
        <EvaluationPanel
          title={author ? `${author} Self-Assessment` : 'Trainee Self-Assessment'}
          value={traineeValue}
          notObservedPrompt={notObservedPrompt}
          notResponsivePrompt={notResponsivePrompt}
          scoreOverrides={scoreOverrides}
          scale={scale}
        />
        <EvaluationPanel
          title={acknowledger ? `${acknowledger} Assessment` : 'Trainer Assessment'}
          value={trainerValue}
          notObservedPrompt={notObservedPrompt}
          notResponsivePrompt={notResponsivePrompt}
          scoreOverrides={scoreOverrides}
          scale={scale}
        />
      </div>
    </div>
  );
};

export default EvaluationRatingElement;
export {EvaluationPanel};
